/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Audio_Recorder_Preview_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to preview recording: {error}" |
*
* @param {Audio_Recorder_Preview_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_preview_failed = /** @type {((inputs: Audio_Recorder_Preview_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Preview_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de la prévisualisation de l'enregistrement : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Aufzeichnung konnte nicht in der Vorschau angezeigt werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile visualizzare l'anteprima della registrazione: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось предварительно просмотреть запись: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo obtener una vista previa de la grabación: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`录制预览失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`録画のプレビューに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`रिकॉर्डिंग का पूर्वावलोकन करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao visualizar a gravação: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to preview recording: ${i?.error}`)
});